(() => {
  if (window.laceyMarqueeInstalled) return;
  window.laceyMarqueeInstalled = true;
  const instances = new Map();
  function mount(root) {
    root.querySelectorAll('.announcement-marquee').forEach(bar => {
      if (instances.has(bar)) return;
      const messages = bar.querySelector('.announcement-marquee__messages');
      if (!messages || !messages.children.length) return;
      const speed = Number(bar.dataset.speed);
      if (!Number.isFinite(speed) || speed === 0) return;
      bar.style.setProperty('--announcement-direction', speed < 0 ? 'reverse' : 'normal');
      const copy = messages.cloneNode(true);
      copy.dataset.marqueeCopy = '';
      copy.setAttribute('aria-hidden', 'true');
      copy.querySelectorAll('a').forEach(link => link.tabIndex = -1);
      messages.after(copy);
      const resize = () => {
        bar.style.setProperty('--announcement-width', bar.clientWidth + 'px');
        bar.style.setProperty('--announcement-duration', (messages.getBoundingClientRect().width / (Math.abs(speed) * 60)) + 's');
      };
      resize();
      bar.classList.add('is-moving');
      const observer = new ResizeObserver(resize);
      observer.observe(messages);
      observer.observe(bar);
      instances.set(bar, observer);
    });
  }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((observer, bar) => {
      if (event.target.contains(bar)) { observer.disconnect(); instances.delete(bar); }
    });
  });
})();
